import React, { createContext, useContext, useState } from "react";

const ThemeContext = createContext();

export const useThemeContext = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    const [clientThemeSettings, setClientThemeSettings] = useState(undefined);

    return (
        <ThemeContext.Provider value={{ clientThemeSettings, setClientThemeSettings }}>
            {children}
        </ThemeContext.Provider>
    );
};